"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _react = require("react");

var _propTypes = _interopRequireDefault(require("prop-types"));

var _lodash = _interopRequireDefault(require("lodash.deburr"));

var _lodash2 = _interopRequireDefault(require("lodash.isequal"));

var _TextField = _interopRequireDefault(require("@material-ui/core/TextField"));

var _MenuItem = _interopRequireDefault(require("@material-ui/core/MenuItem"));

var _Paper = _interopRequireDefault(require("@material-ui/core/Paper"));

var _reactAutosuggest = _interopRequireDefault(require("react-autosuggest"));

var _reactReduxI18n = require("react-redux-i18n");

var _jsxRuntime = require("react/jsx-runtime");

var _excluded = ["classes", "inputRef", "ref"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var classes = {
  container: {
    flexGrow: 1,
    position: 'relative'
  },
  suggestionsContainerOpen: {
    position: 'absolute',
    zIndex: 10,
    left: 0,
    right: 0,
    overflow: 'auto',
    maxHeight: 48 * 5
  },
  suggestion: {
    display: 'block'
  },
  suggestionsList: {
    margin: 0,
    padding: 0,
    listStyleType: 'none'
  }
};

var TextSimpleAutocomplete = /*#__PURE__*/function (_Component) {
  (0, _inherits2.default)(TextSimpleAutocomplete, _Component);

  var _super = _createSuper(TextSimpleAutocomplete);

  function TextSimpleAutocomplete(props, context) {
    var _this$props$value;

    var _this;

    (0, _classCallCheck2.default)(this, TextSimpleAutocomplete);
    _this = _super.call(this, props, context);
    _this.state = {
      moreResults: 0,
      maxResult: props.maxResult,
      textValue: ((_this$props$value = _this.props.value) === null || _this$props$value === void 0 ? void 0 : _this$props$value.label) || '',
      stateSuggestions: [],
      optimizedSuggestions: _this.constructOptimizedSuggestions(),
      errorSelection: false
    }; // Binds

    _this.getSuggestions = _this.getSuggestions.bind((0, _assertThisInitialized2.default)(_this));
    _this.shouldRenderSuggestions = _this.shouldRenderSuggestions.bind((0, _assertThisInitialized2.default)(_this));
    _this.handleSuggestionsFetchRequested = _this.handleSuggestionsFetchRequested.bind((0, _assertThisInitialized2.default)(_this));
    _this.handleSuggestionsClearRequested = _this.handleSuggestionsClearRequested.bind((0, _assertThisInitialized2.default)(_this));
    _this.handleChange = _this.handleChange.bind((0, _assertThisInitialized2.default)(_this));
    _this.handleBlur = _this.handleBlur.bind((0, _assertThisInitialized2.default)(_this));
    _this.handleOnSuggestionSelected = _this.handleOnSuggestionSelected.bind((0, _assertThisInitialized2.default)(_this));
    _this.handleMoreResult = _this.handleMoreResult.bind((0, _assertThisInitialized2.default)(_this));
    return _this;
  }

  (0, _createClass2.default)(TextSimpleAutocomplete, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if ((0, _lodash2.default)(prevProps.suggestions, this.props.suggestions)) {
        return;
      }

      this.setState({
        optimizedSuggestions: this.constructOptimizedSuggestions()
      });
    }
  }, {
    key: "constructOptimizedSuggestions",
    value: function constructOptimizedSuggestions() {
      // Optimize the labels for search efficiency
      var optimizedSuggestions = (0, _toConsumableArray2.default)(this.props.suggestions);
      optimizedSuggestions = optimizedSuggestions.map(function (suggestion) {
        return _objectSpread(_objectSpread({}, suggestion), {}, {
          optimizedLabel: (0, _lodash.default)(suggestion.label).toLowerCase()
        });
      });
      return optimizedSuggestions;
    }
  }, {
    key: "renderInputComponent",
    value: function renderInputComponent(inputProps) {
      var inputClasses = inputProps.classes,
          _inputProps$inputRef = inputProps.inputRef,
          _inputRef = _inputProps$inputRef === void 0 ? function () {} : _inputProps$inputRef,
          ref = inputProps.ref,
          other = (0, _objectWithoutProperties2.default)(inputProps, _excluded);

      return /*#__PURE__*/(0, _jsxRuntime.jsx)(_TextField.default, _objectSpread({
        InputProps: {
          inputRef: function inputRef(node) {
            ref(node);

            _inputRef(node);
          },
          classes: {
            input: inputClasses.input
          }
        }
      }, other));
    }
  }, {
    key: "renderSuggestion",
    value: function renderSuggestion(suggestion, _ref) {
      var query = _ref.query,
          isHighlighted = _ref.isHighlighted;
      var result = [suggestion.label];

      if (query.length > 0) {
        var localQuery = (0, _lodash.default)(query).toLowerCase();
        var indexFound = suggestion.optimizedLabel.indexOf(localQuery);
        result = [suggestion.label.substring(0, indexFound), suggestion.label.substring(indexFound, indexFound + query.length), suggestion.label.substring(indexFound + query.length, suggestion.label.length)];
      }

      return /*#__PURE__*/(0, _jsxRuntime.jsx)(_MenuItem.default, {
        selected: isHighlighted,
        component: "div",
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
          className: "ellipsis",
          children: result.map(function (part, index) {
            return /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
              style: {
                fontWeight: index % 2 ? 500 : 400
              },
              children: part
            }, part + index);
          })
        })
      });
    }
  }, {
    key: "getSuggestions",
    value: function getSuggestions(value) {
      // Note: max result is calculated, because there is no sync between this method and this.handleChange
      var maxResult = this.state.textValue === value ? this.state.maxResult : this.props.maxResult;
      var inputValue = (0, _lodash.default)(value.trim()).toLowerCase();
      var count = 0;
      var moreResults = 0;
      var suggestions = this.state.optimizedSuggestions.filter(function (suggestion) {
        if (count < maxResult) {
          var isIncluded = suggestion.optimizedLabel.includes(inputValue);

          if (isIncluded) {
            count += 1;
          }

          return isIncluded;
        }

        if (suggestion.optimizedLabel.includes(inputValue)) {
          moreResults += 1;
        }

        return false;
      });
      this.setState({
        moreResults: moreResults,
        errorSelection: inputValue.length > 0 && suggestions.length === 0
      });
      return suggestions;
    }
  }, {
    key: "getSuggestionValue",
    value: function getSuggestionValue(suggestion) {
      return suggestion.label;
    }
  }, {
    key: "shouldRenderSuggestions",
    value: function shouldRenderSuggestions() {
      return this.state.textValue.length >= this.props.minimumCharsToRenderResults;
    }
  }, {
    key: "handleSuggestionsFetchRequested",
    value: function handleSuggestionsFetchRequested(_ref2) {
      var value = _ref2.value;
      this.setState({
        stateSuggestions: this.getSuggestions(value)
      });
    }
  }, {
    key: "handleSuggestionsClearRequested",
    value: function handleSuggestionsClearRequested() {
      this.setState({
        stateSuggestions: [],
        moreResults: 0
      });
    }
  }, {
    key: "constructAutosuggestEvent",
    value: function constructAutosuggestEvent() {
      var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
      return {
        target: {
          value: value,
          type: 'autosuggest'
        }
      };
    }
  }, {
    key: "handleChange",
    value: function handleChange(event, _ref3) {
      var textValue = _ref3.newValue;
      event.preventDefault();
      event.stopPropagation();
      this.setState({
        textValue: textValue,
        moreResults: 0,
        maxResult: this.props.maxResult,
        errorSelection: false
      });
      this.props.onChange(this.constructAutosuggestEvent());
    }
  }, {
    key: "handleBlur",
    value: function handleBlur() {
      var _this$props$value2;

      this.setState({
        textValue: ((_this$props$value2 = this.props.value) === null || _this$props$value2 === void 0 ? void 0 : _this$props$value2.label) || '',
        moreResults: 0,
        maxResult: this.props.maxResult,
        errorSelection: false
      });
    }
  }, {
    key: "handleOnSuggestionSelected",
    value: function handleOnSuggestionSelected(event, suggestionSelected) {
      event.preventDefault();
      event.stopPropagation();
      this.setState({
        moreResults: 0,
        maxResult: this.props.maxResult
      });
      this.props.onChange(this.constructAutosuggestEvent(suggestionSelected.suggestion));
    }
  }, {
    key: "handleMoreResult",
    value: function handleMoreResult(event) {
      var _this2 = this;

      event.preventDefault();
      event.stopPropagation();
      this.setState({
        maxResult: this.state.maxResult + this.props.maxResult
      }, function () {
        _this2.setState({
          stateSuggestions: _this2.getSuggestions(_this2.state.textValue)
        });
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;

      return /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactAutosuggest.default, {
        renderInputComponent: this.renderInputComponent,
        shouldRenderSuggestions: this.shouldRenderSuggestions,
        suggestions: this.state.stateSuggestions,
        onSuggestionsFetchRequested: this.handleSuggestionsFetchRequested,
        onSuggestionsClearRequested: this.handleSuggestionsClearRequested,
        getSuggestionValue: this.getSuggestionValue,
        renderSuggestion: this.renderSuggestion,
        onSuggestionSelected: this.handleOnSuggestionSelected,
        highlightFirstSuggestion: true,
        inputProps: {
          classes: classes,
          placeholder: this.props.placeholder,
          value: this.state.textValue,
          onChange: this.handleChange,
          label: this.props.label,
          error: this.props.error || this.state.errorSelection,
          disabled: this.props.disabled,
          helperText: this.props.helperText,
          onBlur: this.handleBlur,
          autoComplete: 'off'
        },
        theme: {
          container: classes.container,
          suggestionsContainerOpen: classes.suggestionsContainerOpen,
          suggestionsList: classes.suggestionsList,
          suggestion: classes.suggestion
        },
        renderSuggestionsContainer: function renderSuggestionsContainer(options) {
          return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_Paper.default, _objectSpread(_objectSpread({}, options.containerProps), {}, {
            square: true,
            children: [options.children, _this3.state.moreResults > 0 && /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
              className: "background-lighter information",
              children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_MenuItem.default, {
                onClick: _this3.handleMoreResult,
                component: "div",
                children: /*#__PURE__*/(0, _jsxRuntime.jsx)("strong", {
                  children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactReduxI18n.Translate, {
                    value: "message.moreResults",
                    results: _this3.state.moreResults
                  })
                })
              })
            })]
          }));
        }
      });
    }
  }]);
  return TextSimpleAutocomplete;
}(_react.Component);

TextSimpleAutocomplete.defaultProps = {
  suggestions: [],
  placeholder: '',
  label: null,
  minimumCharsToRenderResults: 3,
  maxResult: Number.MAX_SAFE_INTEGER
};
TextSimpleAutocomplete.propTypes = {
  onChange: _propTypes.default.func.isRequired,
  value: _propTypes.default.object,
  suggestions: _propTypes.default.array,
  placeholder: _propTypes.default.string,
  label: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.object]),
  error: _propTypes.default.bool,
  disabled: _propTypes.default.bool,
  helperText: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.object]),
  minimumCharsToRenderResults: _propTypes.default.number,
  maxResult: _propTypes.default.number
};
var _default = TextSimpleAutocomplete;
exports.default = _default;
//# sourceMappingURL=TextSimpleAutocomplete.js.map